import React from 'react';
import { css, Flex } from 'theme-ui';
import { styles, cardStyles, getStylesByVariant } from './styles';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import ContentText from '@solid-ui-components/ContentText';

const ContactCard = ({ icon, text, collection, variant }) => {
  const { container, infoText } = getStylesByVariant(variant);
  return (
    <Flex sx={{ ...cardStyles.container, ...container }}>
      <Icon content={icon} size='sm' mb={5} />
      <ContentText content={text} />
      {collection &&
        collection[0].text.map((info, index) => (
          <a
            key={`contact-info-${index}`}
            css={css({ ...cardStyles.infoText, ...infoText })}
            href={`mailto:${info.text}`}
          >
            {info.text}
          </a>
        ))}
    </Flex>
  );
};

const ContactCards = ({ content: { collection }, variants = [] }) => (
  <Flex sx={styles.wrapper}>
    {collection.map(({ icon, text, collection }, index) => (
      <ContactCard
        key={`contact-card-${index}`}
        icon={icon}
        text={text}
        collection={collection}
        variant={variants[index]}
      />
    ))}
  </Flex>
);

export default ContactCards;
